import { ContactOptions } from '../../../../Model/Lead';

const texts = {
  contactOptions: {
    [ContactOptions.EMAIL]: 'Email - {contact}',
    [ContactOptions.SMS]: 'Text/iMessage - {contact}',
  },
  title: 'Send Onboarding Link',
  selectOption: 'Select Option',
  sendContract: 'Send',
  message: '{leadName}, here is your sign up link for {coachName}: {link}',
  success: 'Contract sent successfully',
  fail: 'Failed to send a contract. {error}',
};

export default texts;
